export const componentName = 'league-table-chart';
